import { guid } from 'apps/builder/lib/utils'


// assumptions:
// we need to simultaneously create deterministic non-colliding guids
// in our case, we need to take a entry guid, some additional identifier unique to a redux action and then get a new guid. This allows us to create the same new guid in multiple non-dependent reducers
// it's not important that the guid be cryptographically secure

//(http://www.burtleburtle.net/bob/hash/doobs.html)
//Takes a string of any size and returns an avalanching hash string of 8 hex characters.
export const jenkinsOneAtATimeHash = (keyString = '') => {
  let hash = 0
  for (let charIndex = 0; charIndex < keyString.length; ++charIndex) {
    hash += keyString.charCodeAt(charIndex)
    hash += hash << 10
    hash ^= hash >> 6
  }
  hash += hash << 3
  hash ^= hash >> 11
  //4,294,967,295 is FFFFFFFF, the maximum 32 bit unsigned integer value, used here as a mask.
  return (((hash + (hash << 15)) & 4294967295) >>> 0).toString(16)
}

// 40 char output
export const deterministicGuid = (guid, seed) => {
  if (!seed) {
    throw Error('no seed!')
  }
  return (
    jenkinsOneAtATimeHash(guid) +
    jenkinsOneAtATimeHash(guid + seed) +
    jenkinsOneAtATimeHash(seed) +
    jenkinsOneAtATimeHash(seed + guid) +
    jenkinsOneAtATimeHash(guid)
  ).toUpperCase()
}
